import styled from '@emotion/styled'
import * as React from 'react'

import { typography } from '../constants'
import Text from './Text'

interface IProps {
  children: React.ReactNode
}

export default styled(Text.withComponent('label'))<IProps>`
  font-weight: ${typography.fontWeight.bold};
`
